import { render } from "./CategorySearchResults.vue?vue&type=template&id=8748a278&scoped=true&ts=true"
import script from "./CategorySearchResults.vue?vue&type=script&lang=ts"
export * from "./CategorySearchResults.vue?vue&type=script&lang=ts"

import "./CategorySearchResults.vue?vue&type=style&index=0&id=8748a278&scoped=true&lang=scss"
import "./CategorySearchResults.vue?vue&type=style&index=1&id=8748a278&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8748a278"],['__file',"src/components/product-category-selector/product-category-search-results/CategorySearchResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8748a278"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8748a278', __exports__)) {
    api.reload('8748a278', __exports__)
  }
  
  module.hot.accept("./CategorySearchResults.vue?vue&type=template&id=8748a278&scoped=true&ts=true", () => {
    api.rerender('8748a278', render)
  })

}


export default __exports__